var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MCourseReportPrview_warp"},[_c('div',{staticClass:"content_box"},_vm._l((_vm.pageCount),function(item){return _c('pdf',{key:item,attrs:{"src":_vm.taskInfoData.fullfileurl,"page":item}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }